import { z } from 'zod';
import { IsoTimestampSchema, UuidSchema } from './primitives.js';
import { RiskAssessmentOutcomeSchema, RiskFlagSchema } from './enums.js';
/**
 * USP #2 — Pre-flight Check.
 *
 * Run BEFORE a transfer is finalized, so the user can either confirm a higher
 * risk path explicitly or upload a justification document upfront — which is
 * documented to accelerate the formal review.
 */
export const RiskAssessmentSchema = z.object({
    id: UuidSchema,
    user_id: UuidSchema,
    /** Local ID of the pending TransactionIntent (created in Phase 3). */
    transaction_intent_id: UuidSchema,
    /** 0 (no risk) to 100 (block immediately). See COMPLIANCE-PLAYBOOK §4.2 thresholds. */
    risk_score: z.number().int().min(0).max(100),
    flags: z.array(RiskFlagSchema),
    justification_provided: z.string().max(2000).nullable(),
    justification_doc_url: z.string().url().nullable(),
    outcome: RiskAssessmentOutcomeSchema,
    created_at: IsoTimestampSchema,
    resolved_at: IsoTimestampSchema.nullable(),
});
//# sourceMappingURL=risk-assessment.js.map